import { render, staticRenderFns } from "./OverduePendencies.vue?vue&type=template&id=20bea313&scoped=true&"
import script from "./OverduePendencies.vue?vue&type=script&lang=js&"
export * from "./OverduePendencies.vue?vue&type=script&lang=js&"
import style0 from "./OverduePendencies.vue?vue&type=style&index=0&id=20bea313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bea313",
  null
  
)

export default component.exports